import { Component, Input } from '@angular/core';
import { ActivatedRoute, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ModuleService } from '../../../Services/module.service';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';


@Component({
    selector: 'aw-fields-tabs',
    templateUrl: './fields-tabs.component.html',
    styleUrls: ['./fields-tabs.component.less'],
    imports: [MatTabNav, RouterLinkActive, MatTabLink, RouterLink, MatTabNavPanel, RouterOutlet]
})
export class FieldsTabsComponent {
    selectedStepId: string = "";
    public hasMultiMulti: boolean = false;

    @Input()
    stepName: string;

    constructor(private route: ActivatedRoute,
        private moduleService: ModuleService) { }

    ngOnInit() {
        this.route.queryParams.pipe(filter(params => params.stepId))
            .subscribe(params => this.selectedStepId = params.stepId);

        this.hasMultiMulti = this.moduleService.moduleContent.Steps.filter(step => step.HasRecursiveMultiples).length > 0;
    }
}